'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { SwanAssetFolders } from '../../../core/types/enums.js';
import { useSwanHeadConfig } from './head.hook.js';
import { getSwanAssetFolderName } from '../../../core/utilities/manifest.utils.js';
import { SWAN_VERSION_META_NAME } from '../../../core/utilities/swan-version.js';
import { SWAN_PUBLIC_ASSET_FOLDER, SWAN_VERSION } from '../../../core/constants/paths.js';

const SwanPageMeta = ({ swanBaseUrl: l, swanPathType: s, swanTenant: m, swanLocale: h, renderWith: f = Fragment })=>{
    let { swanBaseUrl: x } = useSwanHeadConfig(l, s, m, h), u = `${x}${SWAN_PUBLIC_ASSET_FOLDER}/${getSwanAssetFolderName(SwanAssetFolders.FAVICONS)}`;
    return jsxs(f, {
        children: [
            jsx("meta", {
                charSet: "UTF-8"
            }, "charset"),
            jsx("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }, "viewport"),
            jsx("meta", {
                name: "format-detection",
                content: "telephone=no"
            }, "telephone format detection"),
            jsx("meta", {
                name: SWAN_VERSION_META_NAME,
                content: SWAN_VERSION
            }, SWAN_VERSION_META_NAME),
            jsx("link", {
                rel: "shortcut icon",
                href: `${u}/favicon.ico`
            }, "favIcon"),
            jsx("link", {
                rel: "apple-touch-icon",
                sizes: "152x152",
                href: `${u}/apple-icon-152x152.png`
            }, "favIcon152"),
            jsx("link", {
                rel: "apple-touch-icon",
                sizes: "120x120",
                href: `${u}/apple-icon-120x120.png`
            }, "favIcon120"),
            jsx("link", {
                rel: "apple-touch-icon",
                sizes: "76x76",
                href: `${u}/apple-icon-76x76.png`
            }, "favIcon76"),
            jsx("link", {
                rel: "apple-touch-icon",
                sizes: "60x60",
                href: `${u}/apple-icon-60x60.png`
            }, "favIcon60")
        ]
    });
};

export { SwanPageMeta };
